export const uk = {
    access: 'права доступа',
    id: 'id',
    'product-name': 'название продукта'
};
